import React from "react";
import { acceptedDocuments, acceptedFepa } from "../constants/acceptedDocuments";
import numeral from "numeral";
import { FEATURE_TOGGLE_IMPOSTE, FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS, FEATURE_TOGGLE_INCASSA_SUBITO } from "../config";
import { canSeeColumns } from "../constants/canSeeColumns";
import { FormattedMessage } from "react-intl";

export function getListAcceptedDocument(permissionUser, location) {
  let isPermissionUploadXml = permissionUser ? checkPermission(
    permissionUser.userPermissions, "1", "16"
  ) : false;
  let listFile = acceptedDocuments;
  if (isPermissionUploadXml && location.pathname !== "/folders-edit") {
    listFile = [...acceptedFepa, ...listFile];
  }

  return listFile;
}

export function createStep(
  id, title, desc, position, disableBeacon, style, selector, isFixed
) {
  return {
    id: id,
    title: title,
    text: desc,
    position: position,
    disableBeacon: disableBeacon,
    style: style,
    selector: selector,
    isFixed: isFixed
  };
}

export function findAncestor(el, sel) {
  if (typeof el.closest === "function") {
    return el.closest(sel) || null;
  }
  /* il while serve a IE che ancora non supporta il closest per recupero antenato con classname dato */
  while (el) {
    if (el.matches(sel)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

export function goToURL(url) {
  return window.open(url, "_self");
}

export function convertHTMLEntity(text) {
  const span = document.createElement("span");
  return text.replace(/&[#A-Za-z0-9]+;/gi, (entity) => {
    span.innerHTML = entity;
    return span.innerText;
  });
}

/**
 * dato un array di oggetti e una keyproperty restituisce un array di stringhe o numeri
 * derivanti dal valore di quella key
 * es. arrayObj = [ { foo: 1, bar: 2}, { foo: 3, bar: 4}, { foo: 5, bar: 6} ];
 * getArrayStringFromArrayObject(arrayObj, "foo")
 * return [ 1, 3, 5 ]
 */
export function getArrayStringFromArrayObject(
  arrayObj, keyPropertyLbl, keyPropertyVal
) {
  return arrayObj.map((a) => {
    return {
      label: a[keyPropertyLbl],
      value: a[keyPropertyVal]
    };
  });
}

/**
 * Dato una lista di oggetti, ordina in maniera crescente la lista
 * @param object: la lista di oggetti
 * @param key: la chiave per cui si vuole ordinare dato il valore
 */
export function sortObjectByKey(object, key) {
  // (info.agyoStatus.eventList, "date")
  let objSorted = object.sort(function(a, b) {
    return a[key] - b[key];
  });
  return objSorted;
}

/** va alla pagina documenti e forza una sottocategoria di default con l'uso dei localStorage
 *
 * @navigate: la props per la push della pagina
 * @macroCategory: sempre vuota in modo che non facciamo assunzioni che nel tempo possano cambiare.
 * La ricaveremo in navigationDocument
 * @subCategory: la sottoCategoria in cui si vuole atterrare (usare gli id della sottocategoria es. fatture attive = 1)
 */
export function redirectDocWithForcedSubCat(
  navigate, macroCategory, subCategory
) {
  localStorage.setItem("docMacroCategoria", `${macroCategory}`);
  localStorage.setItem("docSubCategoria", `${subCategory}`);
  navigate("/documenti");
  return true;
}

/**
 * Return value for key into metadata array
 * @param metadata
 * @param keyValue
 */
export function getValueFromInvoiceMetadata(metadata, keyValue) {
  try {
    if (Array.isArray(metadata)) {
      let section = metadata.find((item) => {
        return item.name === keyValue;
      });

      if (section !== undefined) {
        let val = section.correctedValue;
        if (!val) {
          val = section.value;
        }

        if (val) {
          return isNaN(val) ? val : val.replace(".", ",");
        }
      }

      return "";
    } 
    const json = JSON.parse(metadata);
    return json[keyValue];
    
  } catch (e) {
    return "";
  }
}

export function getDateByString(stringDate) {
  let pattern = /(\d{1,2})[-|/](\d{1,2})[-|/](\d{2,4})/;
  let realDate = new Date(stringDate.replace(pattern, "$3-$2-$1")); // il - serve per Windows edge LINT SCHIFO
  return realDate;
}

export function getFormattedDate(date = new Date()) {
  function pad(s) {
    return s < 10 ? "0" + s : s;
  }
  return [pad(date.getDate()), pad(date.getMonth() + 1), date.getFullYear()].join("/");
}

/**
 * Avvia nel browser il download, in input la struttada data
 */
export function startDownloadData(data) {
  try {
    const byteCharacters = data.content ? atob(data.content) : atob(data.encodedContent);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/octet-stream"
    });

    if (window.navigator.msSaveOrOpenBlob) {
      /* IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx*/
      window.navigator.msSaveBlob(blob, data.filename);
    } else {
      /* var blobChrome = new Blob(["\ufeff", atob(result.data.content)]);NOT WORK*/
      const link = document.createElement("a");
      link.download = data.filename;
      const url = URL.createObjectURL(blob);
      link.href = url; // link.href = "data:application/octet-stream;charset=utf-8;base64," + result.data;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (err) {
    // con l'api b2b read il file arriva gia pronto per il download
    const byteCharacters = data.content;
    const blob = new Blob([byteCharacters]);

    if (window.navigator.msSaveOrOpenBlob) {
      /* IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx*/
      window.navigator.msSaveBlob(blob, data.filename);
    } else {
      /* var blobChrome = new Blob(["\ufeff", atob(result.data.content)]);NOT WORK*/
      const link = document.createElement("a");
      link.download = data.filename;
      const url = URL.createObjectURL(blob);
      link.href = url; // link.href = "data:application/octet-stream;charset=utf-8;base64," + result.data;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

/**
 * Funzione che dato il valore esadecimale di un file estrae la sua vera natura.
 * Neppure cambiando estensione file può fregarci!
 * @param signature: ESADECIMALE del file
 *
 * https://www.filesignatures.net/index.php?page=all
 * http://checkfiletype.com/
 */
export function getRealMimeTypeFromSignatureFile(signature) {
  switch (signature) {
  case String(signature.match(/^8950.*/)):
    return "image/png";
    // case String(signature.match(/^4749.*/)):
    //    return "image/gif";
  case String(signature.match(/^FFD8.*/)):
    return "image/jpeg";
  case String(signature.match(/^2550.*/)):
    return "application/pdf";
  case String(signature.match(/^3C3F.*/)):
    return "text/xml";
  case String(signature.match(/^308.*/)):
    return "application/pkcs7";
  case String(signature.match(/^D0CF.*/)) ||
      String(signature.match(/^0D44.*/)) ||
      String(signature.match(/^CF11.*/)) ||
      String(signature.match(/^DBA5.*/)) ||
      String(signature.match(/^ECA5.*/)) ||
      String(signature.match(/^0908.*/)) ||
      String(signature.match(/^FDFF.*/)):
    return "application/msoffice";
  case String(signature.match(/^504B.*/)):
    return "application/vnd.openxmlformats-officedocument";
  case String(signature.match(/^4573.*/) ||
        signature.match(/^4D697474.*/) ||
        signature.match(/^70726F76.*/) ||
        signature.match(/^50726F76.*/) ||
        signature.match(/^50657269.*/) ||
        signature.match(/^63737670.*/) ||
        signature.match(/^70657220.*/) ||
        signature.match(/^2CDA2C.*/) ||
        signature.match(/^2C2C2CD.*/)):
    return "text/csv";
  default:
    return "Unknown filetype";
  }
}

export function padStringLeft(
  string, maxLength, fillString
) {
  string = `${string}`;
  return fillString.repeat(Math.max(0, maxLength - string.length)) + string;
}

export function createAndDownload(element) {
  let download = document.createElement("a");
  let fileName = element.NomeAttachment ? element.NomeAttachment : element.hubId ? element.hubId + ".pdf" : "download.pdf";
  if (fileName.toLowerCase().endsWith("." + element.FormatoAttachment)) {
    fileName = fileName + "." + element.FormatoAttachment;
  }
  download.setAttribute("href", "data:application/octet-stream;charset=utf-8;base64," + element.Attachment);
  download.setAttribute("download", fileName);
  download.click();
}

export function createAndDownloadXml(xmltext, filename) {
  let pom = document.createElement("a");
  let filenameXml = filename + ".xml";
  let bb = new Blob([xmltext], { type: "text/plain" });
  pom.setAttribute("href", window.URL.createObjectURL(bb));
  pom.setAttribute("download", filenameXml);
  pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(":");
  pom.draggable = true;
  pom.classList.add("dragout");
  pom.click();
}

export function checkPermission(
  permissions, groupId, functionId
) {
  let isActive = false;
  if (permissions && permissions.length > 0) {
    let permission = permissions.find((el) => {
      return el.groupId === groupId;
    });
    if (permission) {
      permission = permission.permissions.find((per) => {
        return per.functionId === functionId;
      });
      isActive = permission && permission.isActive !== null && permission.isActive === true;
    }
  }
  return isActive;
}

export function isDate(date) {
  // eslint-disable-next-line eqeqeq
  return !!(
    date &&
    /* problem sonar Date.parse(date.toString()) !== "Invalid Date" && */
    !isNaN(new Date(date.toString())) &&
    Date.parse(date.toString()) > 0
  );
}

/**
 * Se lo spazio di visualizzazione della stringa in input è troppo piccolo allora
 * spezzo la stringa in 2 substring inizio fine con ... al centro. Serve soprattutto
 * per i filename per mantenere la parte iniziale e finale con l'estensione file
 */
export function start_and_end(str) {
  const width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;

  if (str.length > 35 && width > 410) {
    return str.substr(0, 20) + "..." + str.substr(str.length - 10);
  } 
  return str;
  
}

export function truncateInMiddleResponsive(
  str, contentWidth, textWidth
) {
  let stringToSee = str;
  let first = "";
  let last = "";
  if (contentWidth < textWidth) {
    let indexLast = textWidth - contentWidth;
    let percentageSize = Math.floor((str.length * 50) / textWidth);
    first = str.substring(0, (contentWidth / 2) * percentageSize);
    last = str.substring((contentWidth / 2 + indexLast) * percentageSize, str.length);
    stringToSee = first + "..." + last;
  }
  return stringToSee;
}

export function formatBytes(bytes, decimals) {
  if (bytes === 0) return "0 Bytes";
  let k = 1000;
  let dm = decimals + 1 || 3;
  let sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let i = Math.floor(Math.log(bytes) / Math.log(k));
  return numeral(parseFloat((bytes / Math.pow(k, i)).toFixed(dm))).format("0.0,") + " " + sizes[i];
}

export function findVal(object, key) {
  let value;
  Object.keys(object).some((k) => {
    if (k === key) {
      value = object[k];
      return true;
    }
    if (object[k] && typeof object[k] === "object") {
      value = findVal(object[k], key);
      return typeof value !== "undefined";
    }
    return value;
  });
  return value;
}

export function getInitials(text) {
  let initials = text
    ? text
      .split(" ")
      .map(function(s) {
        return s.charAt(0);
      })
      .join("")
      .substr(0, 2)
    : "N/A";
  return initials.toUpperCase();
}

export function openNotificationWithIcon(
  notification, type, title, message, icon, onClose, notificationTime
) {
  notification.destroy();
  let colorBg;
  switch (type) {
  case "error":
    colorBg = "#d82829";
    break;
  case "warning":
    colorBg = "#fdb927";
    break;
  case "success":
    colorBg = "#09822a";
    break;
  default:
    colorBg = "";
    break;
  }

  notification[type]({
    className: "bottomAlert",
    message: title,
    description: message,
    duration: notificationTime ? notificationTime : 30, // Attenzione non modificare il tempo, se serve piuttosto parametrizzare e settare a 30 le notifiche dell'upload
    placement: "bottomLeft",
    icon: icon,
    onClose: onClose,
    style: {
      backgroundColor: "#FFF",
      border: "1px solid " + colorBg,
      borderBottomWidth: "4px",
      borderRadius: 0,
      marginTop: "10px",
      marginLeft: "0",
      zIndex: 10000000000
    }
  });
}

export function isAccountantUser(companyProp) {
  return companyProp && companyProp.companies.findIndex((el) => el.classifier === "STUDIO") >= 0;
}

export function getValueFromInvoice(invoice, value) {
  let valueToReturn = invoice.find((el) => el.label === value);
  return valueToReturn ? valueToReturn.value : "";
}

export function getGreetingTime(m) {
  let g = null; // return g

  if (!m || !m.isValid()) {
    return undefined;
  } // if we can't find a valid or filled moment, we return.

  const split_afternoon = 12; // 24hr time to split the afternoon
  const split_evening = 17; // 24hr time to split the evening
  const currentHour = parseFloat(m.format("HH"));

  if (currentHour >= split_afternoon && currentHour <= split_evening) {
    g = <FormattedMessage id="generic.goodEvening" />;
  } else if (currentHour >= split_evening) {
    g = <FormattedMessage id="generic.goodEvening" />;
  } else {
    g = <FormattedMessage id="generic.goodMorning" />;
  }

  return g;
}

export const identifyUserAndAccount = ({ user, account }) => {
  if (window.aptrinsic) {
    window.aptrinsic(
      "identify",
      {
        ...user,
        screenResolution: `${window.screen.width}x${window.screen.height}`
      },
      account
    );
  }
};

export const checkDuplicate = (arr) => {
  // empty object
  let map = {};
  let result = false;
  for (let i = 0; i < arr.length; i++) {
    // check if object contains entry with this element as key
    if (map[arr[i]]) {
      result = true;
      // terminate the loop
      break;
    }
    // add entry in object with the element as key
    map[arr[i]] = true;
  }
  return result;
};

export const tick = () => {
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
};

export const canSeeColumnsFiltered = (intl = null, es = false) => canSeeColumns(intl, es).map((col) => {
  if (col.children) {
    if (FEATURE_TOGGLE_INCASSA_SUBITO !== "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && FEATURE_TOGGLE_IMPOSTE === "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "incassaSubito")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO !== "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && FEATURE_TOGGLE_IMPOSTE === "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "business" && ch.dataIndex !== "incassaSubito")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO !== true && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && FEATURE_TOGGLE_IMPOSTE !== "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "imposte" && ch.dataIndex !== "incassaSubito" && ch.dataIndex !== "business")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO === "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && FEATURE_TOGGLE_IMPOSTE !== "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "business" && ch.dataIndex !== "imposte")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO === "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && FEATURE_TOGGLE_IMPOSTE !== "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "imposte")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO !== "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && FEATURE_TOGGLE_IMPOSTE !== "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "imposte" && ch.dataIndex !== "incassaSubito")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO === "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS !== "true" && FEATURE_TOGGLE_IMPOSTE === "true") {
      return {
        ...col,
        children: col.children.filter((ch) => ch.dataIndex !== "business")
      };
    } else if (FEATURE_TOGGLE_INCASSA_SUBITO === "true" && FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" && FEATURE_TOGGLE_IMPOSTE === "true") {
      return {
        ...col,
        children: col.children
      };
    }
  } else {
    return col;
  }
  return null;
});

export const removeMinus = (amount) => {
  if (amount < 0) {
    return amount * -1;
  }
  return amount;
};

export const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));

export const isNumeric = (val) => {
  return /^-?\d+$/.test(val);
};
